<template>
  <div class="modal" id="popup" tabindex="-1" role="dialog">
    <div class="modal-dialog-centered" role="document">
      <MobialisCard class="modal-content popupCard text-center mx-auto">
        <h2 class="w-75 mx-auto mt-4 mb-3">{{ $t('message.popup.closeDefault') }}</h2>
        <p class="loseProgressMessage">{{ $t('message.popup.mayLoseProgress') }}</p>
        <div class="mx-auto mt-4">
          <MobialisButton
            @click="shouldIStay"
            v-av-analytics-cta-interaction="{ elementText: $t('message.popup.stay'), eventActionResult: 'clear' }"
            data-test="stayBtn"
            variant="secondary"
            class="w-auto mr-3"
          >
            {{ $t('message.popup.stay') }}
          </MobialisButton>
          <MobialisButton
            @click="orShouldIGo"
            v-av-analytics-cta-interaction="{ elementText: $t('message.popup.leave'), eventActionResult: 'exit' }"
            data-test="goBtn"
            class="w-auto"
          >
            {{ $t('message.popup.leave') }}
          </MobialisButton>
        </div>
      </MobialisCard>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClosePopup',
  methods: {
    shouldIStay() {
      this.$emit('stay');
    },
    orShouldIGo() {
      this.$emit('go');
    },
  },
};
</script>

<style>
#popup {
  width: 100%;
  display: block;
  z-index: 99999;
  transform: translateZ(0);
  /* background-color: rgba(0, 0, 0, 0.1); */
}
.popupCard {
  max-width: 330px;
  margin-bottom: 40%;
}
.lightbtn {
  background-color: #f0f4f7;
}
.loseProgressMessage {
  font-size: 14px;
  line-height: 21px;
}
</style>
